var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69355 9.25089C5.37412 7.20918 7.28481 5.83203 9.43697 5.83203H10.5627C12.7149 5.83203 14.6256 7.20918 15.3061 9.25089L16.1395 11.7509C17.2187 14.9885 14.8088 18.332 11.396 18.332H8.60363C5.19085 18.332 2.781 14.9885 3.86022 11.7509L4.69355 9.25089Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7381 5.83463L8.2616 5.83463L7.09403 4.49543C5.9495 3.18266 7.28471 1.22045 8.95573 1.75951L9.72887 2.00892C9.9049 2.0657 10.0948 2.0657 10.2708 2.00892L11.0439 1.75951C12.715 1.22045 14.0502 3.18266 12.9056 4.49543L11.7381 5.83463Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.168C9.37866 15.2636 10.4815 15.2883 12.5 14.168",
    stroke: "#1C1C1C",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBagIcon);
export default __webpack_public_path__ + "static/media/money-bag-icon.a9a6ece2414738699d3cd9b48e2e643d.svg";
export { ForwardRef as ReactComponent };